import { render, staticRenderFns } from "./museum.vue?vue&type=template&id=3cd92a4b&scoped=true&"
import script from "./museum.vue?vue&type=script&lang=js&"
export * from "./museum.vue?vue&type=script&lang=js&"
import style0 from "./museum.vue?vue&type=style&index=0&id=3cd92a4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd92a4b",
  null
  
)

export default component.exports